import React from "react";
import { Button } from "react-bootstrap";
import { FaCircleNotch } from 'react-icons/fa';
import "./LoaderButton.css";

export default ({
  isLoading,
  text,
  loadingText,
  className = "",
  disabled = false,
  ...props
}) =>
  <Button
    className={`LoaderButton ${className}`}
    disabled={disabled || isLoading}
    {...props}
  >
    {isLoading && <FaCircleNotch className="spinning" />}
    {!isLoading ? text : loadingText}
  </Button>;
